<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-字典配置-修改
    -->
    <el-dialog
    title="修改字典配置"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      
          
      <el-form-item label="类型" >
        <el-select v-model="form.code" placeholder="请选择类型">
          <el-option v-for="(item,index) in type" :key="index" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </el-form-item>   

      <el-form-item label="字典配置名称" prop="name"><el-input v-model="form.name" placeholder="请输入字典配置名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="key值" prop="keys" >
        <el-input v-model="form.keys" placeholder="请输入key值" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="值" prop="code" v-if="form.code == 'text'">
        <el-input v-model="form.val" placeholder="请输入值" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="颜色" prop="content.titleBackgroundColor" v-if="form.code == 'color'">
        <div class="d-s-c">
          <el-color-picker v-model="form.val"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="字典配置图片：" v-if="form.code == 'image'" prop="model.image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <!-- 表格类型配置 -->
      <el-form-item label="表格配置" v-if="form.code == 'table'">
        <div class="table-config">
          <div class="table-header">
            <el-button type="primary" size="small" @click="addTableRow">添加行</el-button>
          </div>
          <el-table :data="form.tableData" border style="width: 100%">
            <el-table-column label="图片" width="120">
              <template slot-scope="scope">
                <div class="table-img-wrapper">
                  <div class="table-img-box" v-if="scope.row.image">
                    <img :src="scope.row.image" class="table-img"/>
                    <i class="el-icon-close delete-img-icon" @click="deleteTableImage(scope.$index)"></i>
                  </div>
                  <div class="table-img-add" v-else @click="openTableImageUpload(scope.$index)">
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="标题">
              <template slot-scope="scope">
                <el-input v-model="scope.row.title" placeholder="请输入标题" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="副标题">
              <template slot-scope="scope">
                <el-input v-model="scope.row.subtitle" placeholder="请输入副标题" size="small"></el-input>
              </template>
            </el-table-column>
                     <el-table-column label="副标题二">
              <template slot-scope="scope">
                <el-input v-model="scope.row.subtitlet" placeholder="副标题二" size="small"></el-input>
              </template>
            </el-table-column>


            <el-table-column  label="跳转链接" width="300">
                <template slot-scope="scope">
                <div class="d-s-c">
                    <div class="url-box flex-1">
          
                      <el-input
                        placeholder="请选择跳转地址"
                        :value="scope.row.name+scope.row.linkUrl"
                      ></el-input>
                    </div>
                    <div class="url-box ml10">
                      <el-button type="primary" @click="changeLink(scope.$index)"
                        >选择链接</el-button
                      >
                    </div>
                </div>
            </template>
            </el-table-column>


            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="deleteTableRow(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <el-form-item label="备注" prop="note" >
        <el-input v-model="form.note" type="textarea" placeholder="请输入备注" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- 表格图片上传组件 -->
    <Upload v-if="isTableUpload" :config="{ total: 1 }" :isupload="isTableUpload" @returnImgs="returnTableImgsFunc">上传图片
    </Upload>
  </div>
      <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
</el-dialog>
  
</template>

<script>
import DictApi from '@/api/dict.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Setlink from "@/components/setlink/Setlink";
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Setlink
  },
  data() {
    return {
      is_linkset:false,
      index:0,
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'text',
        image:[],
        val:"",
        keys:"",
        tableData: [], // 表格数据
        sort: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入字典配置名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      isTableUpload: false, // 表格图片上传标识
      currentTableIndex: -1, // 当前编辑的表格行索引
      type:[
        {
          label:"文字",
          val:"text"
        },
        {
          label:"图片",
          val:"image"
        },
        {
          label:"颜色",
          val:"color"
        },
        {
          label:"表格",
          val:"table"
        }
      ]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","dict_id"],
  watch: {
    'form.code'(newVal) {
      // 切换类型时，初始化表格数据
      if (newVal === 'table' && (!this.form.tableData || this.form.tableData.length === 0)) {
        this.form.tableData = [];
      }
    }
  },
  methods: {
    onEditorResetColor() {
      this.form.val = ''
    },
    chooseCategory(){
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },
    
    /*删除商品图片*/
    deleteImg(index,code) {
      this.form.image.splice(index, 1);
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      DictApi.detail({dict_id: self.dict_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
          if(!self.form.image || self.form.image == null){
            self.form.image = [];
          }
          // 处理表格数据
          if(self.form.code === 'table' && self.form.val) {
            try {
              self.form.tableData = JSON.parse(self.form.val) || [];
            } catch(e) {
              self.form.tableData = [];
            }
          } else {
            self.form.tableData = [];
          }
        })
        .catch(error => {});
    },
      /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
         console.log('this.form.tableData',this.form.tableData)
        this.form.tableData[this.index].linkUrl = e.url;
          this.form.tableData[this.index].name = "链接到" + " " + e.type + " " + e.name;
      }
      this.$forceUpdate()
    },  
    // 添加表格行
    addTableRow() {
      this.form.tableData.push({
        image: '',
        title: '',
        subtitle: '',
         subtitlet: '',
      });
    },
    
    // 删除表格行
    deleteTableRow(index) {
      this.$confirm('确定删除该行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.tableData.splice(index, 1);
      }).catch(() => {});
    },
    
    // 打开表格图片上传
    openTableImageUpload(index) {
      this.currentTableIndex = index;
      this.isTableUpload = true;
    },
    
    // 删除表格图片
    deleteTableImage(index) {
      this.form.tableData[index].image = '';
    },
    
    // 返回表格图片上传结果
    returnTableImgsFunc(e) {
      if (e != null && e.length > 0) {
        let imgUrl = e[0].file_path;
        if (this.currentTableIndex !== -1) {
          this.form.tableData[this.currentTableIndex].image = imgUrl;
        }
      }
      this.isTableUpload = false;
      this.currentTableIndex = -1;
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 如果是表格类型，将 tableData 转换为 JSON 字符串存储到 val 字段
      if (form.code === 'table') {
        form.val = JSON.stringify(form.tableData);
      }
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          DictApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 表格样式 */
.table-config {
  width: 100%;
}

.table-header {
  margin-bottom: 10px;
}

.table-img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-img-box {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.table-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-img-icon {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 0, 0, 0.7);
  color: white;
  font-size: 12px;
  cursor: pointer;
  padding: 2px;
  border-radius: 0 0 0 4px;
}

.table-img-add {
  width: 60px;
  height: 60px;
  border: 1px dashed #dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.table-img-add:hover {
  border-color: #409eff;
}

.table-img-add i {
  font-size: 24px;
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/dict/index/part/edit.vue